export default "__VITE_ASSET__2006f1b4__"